const modulo = {
  ANALISE: 'analise',
  PUBLICO: 'publico',
  ARRECADACAO: 'arrecadacao',
  FINANCEIRO: 'financeiro',
  ASSINATURA: 'assinatura',
  GESTAO_DE_DEMANDAS: 'demandas',
  GESTAO_DE_DOCUMENTOS: 'gestao-documentos'
}

export default modulo



// WEBPACK FOOTER //
// ./src/utils/modulo.js